import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.reviews;

export const reviewsSelector = createSelector(getState, (state) => state.reviews);
export const reviewsMetaSelector = createSelector(getState, (state) => state.reviewsMeta);
export const isLoadingReviewsSelector = createSelector(getState, (state) => state.isLoadingReviews);

export const reviewsErrorsSelector = createSelector(getState, (state) => state.reviewsErrors);
